export const darkTheme = {
    bg:"#07111F",
    bgLight: "#0D1B2E",
    primary:"#2DD4BF",
    primarySoft: "rgba(45, 212, 191, 0.16)",
    accent:"#F4C95D",
    accentSoft: "rgba(244, 201, 93, 0.14)",
    text_primary:"#F8FAFC",
    text_secondary:"#A7B4C8",
    card:"#0F1E33",
    card_light: '#132842',
    border:"rgba(148, 163, 184, 0.18)",
    button:"#2DD4BF",
    white:"#FFFFFF",
    black:"#000000",
    soft2:"#7F8EA3",
}

export const lightTheme = {
    bg:"#F8FAFC",
    bgLight: "#EEF4F8",
    primary:"#0F766E",
    primarySoft: "rgba(15, 118, 110, 0.12)",
    accent:"#B7791F",
    accentSoft: "rgba(183, 121, 31, 0.12)",
    text_primary:"#0F172A",
    text_secondary:"#475569",
    card:"#FFFFFF",
    card_light: '#F1F5F9',
    border:"rgba(15, 23, 42, 0.12)",
    button:"#0F766E",
    white:"#FFFFFF",
    black:"#000000",
    soft2:"#64748B",
}
